import Card from 'semantic-ui-react/dist/commonjs/views/Card'
export default Card
